export const STRAVA_CLIENT_ID = process.env.REACT_APP_STRAVA_CLIENT_ID || '144311';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://streventools.com/api';